var map = {
	"./coins": 4,
	"./coins.png": 4,
	"./dots": 5,
	"./dots.png": 5,
	"./dots_solo": 6,
	"./dots_solo.png": 6,
	"./drops": 7,
	"./drops.png": 7,
	"./hono.ico": 20,
	"./hono16": 8,
	"./hono16.ico": 21,
	"./hono16.png": 8,
	"./hono32": 9,
	"./hono32.ico": 22,
	"./hono32.png": 9,
	"./index_dots": 10,
	"./index_dots.png": 10,
	"./khan_academy_logo": 11,
	"./khan_academy_logo.svg": 11,
	"./menu_bg": 12,
	"./menu_bg.png": 12,
	"./pict": 13,
	"./pict.png": 13,
	"./sign": 14,
	"./sign.png": 14,
	"./title": 15,
	"./title.png": 15,
	"./top_bg": 16,
	"./top_bg.png": 16
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 19;